import { Component, effect, ElementRef, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { startWith, filter, switchMap, debounceTime } from 'rxjs/operators';
import { SearchComponent } from '../search/search.component';
import { SearchService } from '@xanadu/service';

@Component({
    selector: 'app-indexer',
    templateUrl: './indexer.component.html',
    styleUrls: ['./indexer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IndexerComponent extends SearchComponent {
    private readonly searchService = inject(SearchService);

    readonly search = viewChild<ElementRef>('search');
    public current: string = '';

    constructor() {
        super();

        effect(() => {
            const formControl = this.formControl();
            if (formControl) {
                this.filtered = formControl.valueChanges
                    .pipe(
                        startWith(''),
                        debounceTime(500),
                        filter(text => typeof text === 'string'),
                        switchMap(text => this.filter(text))
                    );
            }
        });
    }

    public displayWith(_?: any): string {
        setTimeout(() => this.search()?.nativeElement.blur(), 0);
        return this.current;
    }

    protected filter(value: string): Observable<any[]> {
        this.current = value;
        if (value?.length < 2) {
            return of([]);
        }
        const filterValue = value.toLowerCase();

        const result = this.searchService.find(filterValue);
        return result;
    }
}
